<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="col-sm-12">
      <div class="card card-body mb-0">

        <div class="row">
          <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.name')" v-model="requestDTO.query">
              </div>
            </div>
          </div>

          <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <ReferralMultiselect :multiple="true" v-model="referralsFilter"></ReferralMultiselect>
              </div>
            </div>
          </div>

          <div class="form-group col">
            <div class="col-auto p-0 text-end ">
              <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
              <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="card card-body">
        <div class="overflow-auto">
          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <td></td>
              <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.referral') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.rate_source') }}</th>
              <th class="text-end">
                <button v-if="isAdmin && merchantForStores === null" type="button" v-on:click="showEditModal(null)" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                <b-modal dialog-class="modal-lg"
                         :title="createModalTitle"
                         :modelValue="createModal"
                         body-class="pt-0"
                         @update:modelValue="onCreateModalVisibility"
                >
                  <template #default>
                    <MerchantForm ref="createForm" @open-ip-whitelist="onOpenIpWhitelistFromEdit" @open-settings-history="showMerchantHistoryFromForm"></MerchantForm>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="onCreateModalVisibility(false)" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                    <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                      <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                    </LoaderWrapper>
                  </template>
                </b-modal>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="merchant in items" :key="merchant.id" class="">
              <td>
                <i v-b-tooltip.hover :title="helper.trans('labels.user_blocked')" v-if="merchant.isBlocked" class="fa fa-ban text-danger"></i>
              </td>
              <td>{{ merchant.id }}</td>
              <td>
                <UserNameLabel :user="merchant"></UserNameLabel>
              </td>
              <td>
                <div v-if="merchant.referral" class="me-2">
                  <UserNameLabel :user="merchant.referral"></UserNameLabel>
                  {{ helper.floatToPercent(merchant.referralPayInFee) }}% / {{ helper.floatToPercent(merchant.referralPayOutFee) }}%
                </div>
                <div v-if="merchant.referral2" class="me-2">
                  <UserNameLabel :user="merchant.referral2"></UserNameLabel>
                  {{ helper.floatToPercent(merchant.referral2PayInFee) }}% / {{ helper.floatToPercent(merchant.referral2PayOutFee) }}%
                </div>
                <div v-if="merchant.referral3" class="me-2">
                  <UserNameLabel :user="merchant.referral3"></UserNameLabel>
                  {{ helper.floatToPercent(merchant.referral3PayInFee) }}% / {{ helper.floatToPercent(merchant.referral3PayOutFee) }}%
                </div>
                <div v-if="merchant.referral4" class="me-2">
                  <UserNameLabel :user="merchant.referral4"></UserNameLabel>
                  {{ helper.floatToPercent(merchant.referral4PayInFee) }}% / {{ helper.floatToPercent(merchant.referral4PayOutFee) }}%
                </div>
                <div v-if="merchant.referral5">
                  <UserNameLabel :user="merchant.referral5"></UserNameLabel>
                  {{ helper.floatToPercent(merchant.referral5PayInFee) }}% / {{ helper.floatToPercent(merchant.referral5PayOutFee) }}%
                </div>
              </td>
              <td>
                in: {{helper.trans(`rate_sources.${merchant.rateSource}`) }}<br>
                out: {{helper.trans(`rate_sources.${merchant.payOutRateSource}`) }}
              </td>
              <td class="text-end">
                <button v-if="merchantForStores !== null" type="button" @click.prevent="selectMerchantForStores(null)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">
                  <i class="fa fa-arrow-left"></i> {{ helper.trans('button.back')}}
                </button>

                <button v-if="merchantForStores === null" type="button" @click="selectMerchantForStores(merchant)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">{{helper.trans('labels.stores')}}</button>
                <button v-if="isAdmin && store.getters.hasPermission(UserPermission.VIEW_USER_SESSION_HISTORY)" type="button" @click.prevent="downloadSessionHistory(merchant.id)" class="btn btn-sm btn-outline-secondary text-nowrap text-capitalize me-2">
                  <i class="fa fa-file-download"></i> {{helper.trans('button.download_session_history')}}
                </button>
                <button v-if="isAdmin" type="button" @click="showEditModal(merchant)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                <button v-if="isOperator && store.getters.hasPermission(UserPermission.RESET_MERCHANT_PASSWORD)" type="button" @click.prevent="showChangePasswordModal(merchant)" class="ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize">
                  <i class="fa fa-key"></i> {{helper.trans('button.change_password')}}
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <b-pagination
            v-if="response.totalCount > response.items.length && merchantForStores === null"
            v-model="page"
            :total-rows="response.totalCount"
            :per-page="response.limit"
            :limit="20"
            @update:modelValue="changePage()"
            prev-text="Back"
            next-text="Next"
            align="start"
            first-number
            hide-goto-end-buttons
            hide-ellipsis
          ></b-pagination>

        </div>
      </div>
    </div>

    <LoaderWrapper ref="storesLoader" class="h-100">
      <div v-if="merchantForStores">
          <MerchantStoresList :merchant="merchantForStores" :stores="stores" @updated="selectMerchantForStores(merchantForStores)"></MerchantStoresList>
      </div>
    </LoaderWrapper>

    <MerchantIpWhitelistModal ref="ipWhitelistModal" @updated="loadList"></MerchantIpWhitelistModal>

    <SettingsHistoryModal ref="merchantHistoryModal" entity-type="merchant" />
    <ChangePasswordModal ref="changePasswordModal"></ChangePasswordModal>

    <InviteLinkConfirmModal ref="inviteLinkConfirmModal"></InviteLinkConfirmModal>
  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref, watch} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {useSessionHistoryDownload} from "@/service/useSessionHistoryDownload";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import MerchantDTO from "@/models/MerchantDTO";
import MerchantFormDTO from "@/models/form/MerchantFormDTO";
import MerchantForm from "@/components/Form/MerchantForm.vue";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import MerchantStoresList from "@/components/MerchantStoresList.vue";
import MerchantIpWhitelistModal from "@/components/users/MerchantIpWhitelistModal.vue";
import InviteLinkConfirmModal from "@/components/InviteLinkConfirmModal.vue";
import SettingsHistoryModal from "@/components/SettingsHistoryModal.vue";
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";
import {UserPermission} from "@/models/enum/UserPermission";
import {useStore} from "vuex";
import router from "@/router";
import UserNameLabel from "@/components/UserNameLabel.vue";
import ReferralMultiselect from "@/components/ReferralMultiselect.vue";
import UserDTO from "@/models/UserDTO";
import {useRoute} from "vue-router";
import PaginationDTO from "@/models/PaginationDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import {Dictionary} from "@/types";
import {ReceiptForwardMode} from "@/models/enum/ReceiptForwardMode";
import {
  applyReceiptForwardSettingsToMerchant,
  DEFAULT_RECEIPT_FORWARD_ACTIONS,
  DEFAULT_RECEIPT_FORWARD_FIELDS,
  normalizeReceiptForwardSettings,
  receiptForwardSettingsFromSubmitted,
} from "@/service/merchantReceiptForward";

const api = new APIClient();

export default defineComponent({
  components: {
    UserNameLabel,
    ReferralMultiselect,
    LoaderWrapper,
    CopyButton,
    MerchantForm,
    MerchantStoresList,
    MerchantIpWhitelistModal,
    InviteLinkConfirmModal,
    SettingsHistoryModal,
    ChangePasswordModal
  },
  props: {},
  setup() {
    const store = useStore();
    const defaultCreateForm = {
      id: null,
      name: null,
      email: null,
      password: '',
      isBlocked: false,
      isManualWithdrawals: false,
      secret: "",
      createInvite: true,
      referral: null,
      isAvailableWorkWithUnsafeTgGroup: null,
      referralPayInFee: '',
      referralPayInFeeType: 0,
      referralPayOutFee: '',
      referralPayOutFeeType: 0,
      referral2: null,
      referral2PayInFee: '',
      referral2PayInFeeType: 0,
      referral2PayOutFee: '',
      referral2PayOutFeeType: 0,
      referral3: null,
      referral3PayInFee: '',
      referral3PayInFeeType: 0,
      referral3PayOutFee: '',
      referral3PayOutFeeType: 0,
      referral4: null,
      referral4PayInFee: '',
      referral4PayInFeeType: 0,
      referral4PayOutFee: '',
      referral4PayOutFeeType: 0,
      referral5: null,
      referral5PayInFee: '',
      referral5PayInFeeType: 0,
      referral5PayOutFee: '',
      referral5PayOutFeeType: 0,
      rateSource: null,
      payOutRateSource: null,
      traderPayInRateSource: null,
      traderPayOutRateSource: null,
      appId: null,
      tgChatGroupId: null,
      tgReceiptForwardGroupId: null,
      tgReceiptActionsGroupId: null,
      turnoverReportTgGroupId: null,
      turnoverReportSendHour: null,
      turnoverReportMiddayEnabled: false,
      conversionReportTgGroupId: null,
      conversionStatTgGroupId: null,
      conversionReportSendHour: null,
      conversionReportMiddayEnabled: false,
      receiptForwardMode: ReceiptForwardMode.FULL,
      receiptForwardComment: null,
      receiptForwardTargetChatIds: [],
      receiptForwardFields: [...DEFAULT_RECEIPT_FORWARD_FIELDS],
      receiptForwardActions: [...DEFAULT_RECEIPT_FORWARD_ACTIONS],
      siteUploadForwardEnabled: false,
      tgGroups: [],
      is2faEnabled: null,
      antiFraudCancelDeal: null,
      antiFraudCancelDealBannedSeconds: null,
      isIpWhitelistEnabled: false,
      isClientReceiptNotificationEnabled: false,
      isDealCompletedNotificationEnabled: false
    } as MerchantFormDTO
    const route = useRoute()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const storesLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof MerchantForm> | null>(null)
    const inviteLinkConfirmModal = ref<InstanceType<typeof InviteLinkConfirmModal> | null>(null)
    const ipWhitelistModal = ref<InstanceType<typeof MerchantIpWhitelistModal> | null>(null)
    const merchantHistoryModal = ref<InstanceType<typeof SettingsHistoryModal> | null>(null)
    const changePasswordModal = ref<InstanceType<typeof ChangePasswordModal> | null>(null)

    const state = reactive({
      createModalTitle: null,
      createModal: false,
      merchantForStores: null as MerchantDTO|null,
      merchantBeingEdited: null as MerchantDTO|null,
      page: route.query.page ? parseInt(route.query.page as string) : 1,
      stores: [] as MerchantStoreDTO[],
      requestDTO: {
        query: '',
        userIds: []
      } as any,
      referralsFilter: [] as UserDTO[],
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<MerchantDTO>
    });

    const changePage = async () => {
      if (route.query.page?.toString() === state.page.toString()) {
        loadList()
      } else {
        router.push({path: `/admin/users/merchants`, query: {page: state.page}})
      }
    }

    const loadList = async () => {
      loader.value?.show()
      state.response.offset = state.response.limit * (state.page - 1)
      const requestDTO = {
        ...state.requestDTO,
        refIds: state.referralsFilter.map((item) => item.id),
      }
      state.response = await api.merchants(state.response, requestDTO);
      loader.value?.hide()
    }

    const onCreateModalVisibility = (open: boolean) => {
      state.createModal = open
      if (!open) {
        state.merchantBeingEdited = null
      }
    }

    const onOpenIpWhitelistFromEdit = () => {
      const merchant = state.merchantBeingEdited
      if (!merchant) {
        return
      }
      onCreateModalVisibility(false)
      ipWhitelistModal.value?.show(merchant)
    }

    const showEditModal = (dto: MerchantDTO | null) => {
      if (dto && dto.id) {
        state.merchantBeingEdited = dto
        state.createModalTitle = helper.trans("labels.edit_merchant", {name: dto.name})
        createForm.value?.setForm({
          ...defaultCreateForm,
          ...dto,
          isIpWhitelistEnabled: dto.isIpWhitelistEnabled ?? false,
          isClientReceiptNotificationEnabled: dto.isClientReceiptNotificationEnabled ?? false,
          isDealCompletedNotificationEnabled: dto.isDealCompletedNotificationEnabled ?? false,
          turnoverReportMiddayEnabled: dto.turnoverReportMiddayEnabled ?? false,
          conversionReportMiddayEnabled: dto.conversionReportMiddayEnabled ?? false,
          ...normalizeReceiptForwardSettings(dto),
          referral: dto.referral,
          referralPayInFee: dto.referralPayInFee ? helper.floatToPercent(dto.referralPayInFee) : null,
          referralPayOutFee: dto.referralPayOutFee ? helper.floatToPercent(dto.referralPayOutFee) : null,
          referral2: dto.referral2,
          referral2PayInFee: dto.referral2PayInFee ? helper.floatToPercent(dto.referral2PayInFee) : null,
          referral2PayOutFee: dto.referral2PayOutFee ? helper.floatToPercent(dto.referral2PayOutFee) : null,
          referral3: dto.referral3,
          referral3PayInFee: dto.referral3PayInFee ? helper.floatToPercent(dto.referral3PayInFee) : null,
          referral3PayOutFee: dto.referral3PayOutFee ? helper.floatToPercent(dto.referral3PayOutFee) : null,
          referral4: dto.referral4,
          referral4PayInFee: dto.referral4PayInFee ? helper.floatToPercent(dto.referral4PayInFee) : null,
          referral4PayOutFee: dto.referral4PayOutFee ? helper.floatToPercent(dto.referral4PayOutFee) : null,
          referral5: dto.referral5,
          referral5PayInFee: dto.referral5PayInFee ? helper.floatToPercent(dto.referral5PayInFee) : null,
          referral5PayOutFee: dto.referral5PayOutFee ? helper.floatToPercent(dto.referral5PayOutFee) : null,
        } as MerchantFormDTO)
      } else {
        state.merchantBeingEdited = null
        state.createModalTitle = helper.trans("labels.create_merchant")
        createForm.value?.setForm({
          ...defaultCreateForm,
          password: helper.generatePassword(),
          secret: helper.generateRandomString(40)
        } as MerchantFormDTO)
      }

      state.createModal = true;
    }

    const showChangePasswordModal = (merchant: MerchantDTO) => {
      changePasswordModal.value?.show(merchant.id, api.merchantsChangePassword)
    }

    const save = () => {
      loaderCreateFrom.value?.show()
      const submittedForm = createForm.value!.getForm();
      const receiptForwardSettings = receiptForwardSettingsFromSubmitted(submittedForm);

      createForm.value!.save()
        .then(async (merchant: MerchantDTO) => {
          onCreateModalVisibility(false)
          if (merchant.inviteToken) {
            const url = store.getters['getInviteLink'](merchant);
            inviteLinkConfirmModal.value?.show(url);
          }
          await loadList();
          const item = state.response.items.find((i) => i.id === merchant.id)
          if (item) {
            applyReceiptForwardSettingsToMerchant(item, receiptForwardSettings);
          }
          if (state.merchantForStores?.id === merchant.id) {
            applyReceiptForwardSettingsToMerchant(state.merchantForStores, receiptForwardSettings);
          }
        })
        .catch(() => {})
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })

    }

    const selectMerchantForStores = async (merchant: MerchantDTO|null) => {
      if (merchant === null) {
        state.merchantForStores = null
        router.push({path: `/admin/users/merchants`, query: route.query})
        loadList()
        return;
      }
      router.push({path: `/admin/users/merchants/${merchant.id}`, query: route.query})
      state.merchantForStores = merchant;
      storesLoader.value?.show()
      state.stores = await api.merchantsStoresAll(merchant.id);
      let trafficGroupIds = []
      for (const store of state.stores) {
        for (const group of store.trafficGroups) {
          trafficGroupIds.push(group.id)
        }
      }
      if (trafficGroupIds.length > 0) {
        const trafficGroups = (await api.call.trafficGroups.list({limit: trafficGroupIds.length, offset: 0} as PaginationDTO, {ids: trafficGroupIds})).items
        let trafficGroupsById = {} as Dictionary<TrafficGroupDTO>;
        for (const group of trafficGroups) {
          trafficGroupsById[group.id] = group
        }

        for (const store of state.stores) {
          for (const item of store.trafficGroups) {
            item._trafficGroup = trafficGroupsById[item.id] ?? null
          }
        }
      }

      store.dispatch('merchantStores/setStores', state.stores)
      storesLoader.value?.hide()
    }

    const items = computed<MerchantDTO[]>(() => {
      return state.merchantForStores !== null
        ? [state.merchantForStores]
        : state.response.items
    })

    const applyFilters = async () => {
      state.merchantForStores = null
      state.page = 1;
      changePage()
    }

    const clearFilters = async () => {
      state.merchantForStores = null
      state.page = 1;
      state.requestDTO = {
        query: ''
      }
      state.referralsFilter = []
      changePage()
    }

    const showMerchantHistoryFromForm = () => {
      const form = createForm.value?.getForm()
      if (!form?.id) {
        return
      }

      merchantHistoryModal.value?.show(
        form.id,
        helper.trans('labels.settings_history') + `: ${form.name}`,
      )
    }

    watch(() => route.query.page, async () => {
      state.merchantForStores = null
      state.page = route.query.page ? parseInt(route.query.page as string) : 1
      loadList()
    })

    onMounted(async () => {
      store.dispatch('rateSources/loadList')
      if (route.params.id) {
        state.requestDTO.userIds = [route.params.id]
        loader.value?.show()
        state.response.offset = 0
        state.response = await api.merchants(state.response, state.requestDTO);
        loader.value?.hide()
        state.requestDTO.userIds = []
        selectMerchantForStores(state.response.items[0])

      } else {
        loadList()
      }
    });

    const {downloadSessionHistory} = useSessionHistoryDownload(loader)

    return {
      downloadSessionHistory,
      ...toRefs(state),
      loader,
      dateHelper,
      numberFormatter,
      createForm,
      loaderCreateFrom,
      helper,
      items,
      loadList,
      changePage,
      selectMerchantForStores,
      showEditModal,
      save,
      storesLoader,
      inviteLinkConfirmModal,
      ipWhitelistModal,
      applyFilters,
      clearFilters,
      onCreateModalVisibility,
      onOpenIpWhitelistFromEdit,
      showMerchantHistoryFromForm,
      merchantHistoryModal,
      changePasswordModal,
      showChangePasswordModal,
      store,
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      UserPermission,
    }
  }
})
</script>
